import * as yup from 'yup';

export const CreateUserValidationSchema = yup.object().shape({
	firstName: yup
		.string()
		.trim()
		.required('First name is required')
		.min(2, 'First name must be at least 2 characters')
		.max(255, 'First name must be less than 255 characters'),
	lastName: yup
		.string()
		.trim()
		.required('Last name is required')
		.min(2, 'Last name must be at least 2 characters')
		.max(255, 'Last name must be less than 255 characters'),
	type: yup
		.string()
		.required('User type is required')
		.oneOf(['superadmin', 'general'], 'Invalid user type'),
	email: yup
		.string()
		.trim()
		.email('Please enter a valid email address')
		.required('Email is required')
		.max(255, 'Email must be less than 255 characters'),
	password: yup
		.string()
		.trim()
		.required('Password is required')
		.min(8, 'Password must be at least 8 characters'),
});

export const ResetUserPasswordValidationScheme = yup.object().shape({
	new_password: yup
		.string()
		.trim()
		.required('New Password is required')
		.min(8, 'New Password must be at least 8 characters'),
});
